module.exports = __webpack_public_path__ + "img/tip.26aaef20.jpg";